// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1F0E_","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__m733E"};